import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import classes from "./authorization.module.scss";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { selectApiError } from "../../reducers/app/selectors";
import { Modal } from "antd";
import { setApiError } from "../../reducers/app/actions";
import {isEmpty, isNil, propOr} from "ramda";
import {PDFCO_APP_ORIGIN} from "../../constants/common";

const Authorization = () => {
  const dispatch = useDispatch();
  const apiError = useSelector(selectApiError);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [titleMessage, setTitleMessage] = useState("");
  const [bodyMessage, setBodyMessage] = useState("");
  const [okBtn, setOkBtn] = useState("");
  const [cancelBtn, setCancelButton] = useState("Cancel");

  const handleOnClose = () => {
    setIsOpenModal(false);
    dispatch(setApiError(null));
  };

  useEffect(() => {
    if (isNil(apiError)) return;

    switch (apiError.errorCode) {
      case 402: {
        setTitleMessage("Sorry, not enough credits");
        setBodyMessage(
          <div>
            Sorry but it looks like you ran out of credits for PDF.co. To add
            credits please use{" "}
            <a href="https://app.pdf.co/subscriptions" target="_blank">
              this page
            </a>
            .
          </div>
        );
        setOkBtn(
          <a href="https://app.pdf.co/subscriptions" target="_blank">
            <button
              className={classNames(
                "btn btn-primary",
                classes.OpenCreditsPageBtn
              )}
            >
              Open Credits Page
            </button>
          </a>
        );
        setCancelButton("Cancel");
        setIsOpenModal(true);
        break;
      }

      case 401:
      case 403: {
        setTitleMessage("Sorry, the UI session has expired");
        setBodyMessage(
          <div>
            Sorry, your UI session has expired. Please refresh the page to
            re-initiate the session.
            <br />
            <br />
            If refreshing does not help then please return to the dashboard and
            make sure you are logged in.
          </div>
        );
        setOkBtn(
          <button
            className={classNames(
              "btn btn-primary",
              classes.OpenCreditsPageBtn
            )}
            onClick={() => {
              window.location.reload();
              handleOnClose();
            }}
          >
            Refresh
          </button>
        );
        setCancelButton("Cancel");
        setIsOpenModal(true);
        break;
      }

      default: {
        const responseMessage = propOr("", "message", apiError);
        setTitleMessage("An error occurred while processing your request!");
        setBodyMessage(
          <div>
            {isEmpty(responseMessage)
              ? "An unexpected error occurred! Please try again!"
              : responseMessage}

            <div className={"small mt-3"}>
              <a href={`${PDFCO_APP_ORIGIN}/logs/api`}>
                Check API logs for details
              </a>
            </div>
            <div className={"small"}>
              <a href="https://apidocs.pdf.co/kb">
                Explore PDF.co Knowledgebase
              </a>
            </div>
            <div className={"small"}>
              <a
                href={`https://support.bytescout.com/hc/en-us/requests/new?subject=Document%20Parser%20Template%20Editor%20${responseMessage}`}
              >
                Contact Customer Support
              </a>
            </div>
          </div>
        );
        setOkBtn(
          <button
            className={classNames("btn btn-primary OpenCreditsPageBtn")}
            onClick={() => {
              window.location.reload();
              handleOnClose();
            }}
          >
            Refresh
          </button>
        );
        setCancelButton("Close");
        setIsOpenModal(true);
        break;
      }
    }
  }, [apiError]);

  return (
    <div>
      <Modal
        title={null}
        open={isOpenModal}
        footer={null}
        onCancel={handleOnClose}
        className={classes.Modal}
      >
        <div className={classes.TitleWrap}>
          <div className={classes.IconWrap}>
            <FontAwesomeIcon
              icon={faCircleExclamation}
              className="text-danger"
            />
          </div>
          <div className={classes.Title}>{titleMessage}</div>
        </div>
        <div className={classes.BodyWrap}>{bodyMessage}</div>

        <div className={classes.FooterWrap}>
          {okBtn}
          <button className="btn btn-outline-secondary" onClick={handleOnClose}>
            {cancelBtn}
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default Authorization;
